import { HttpContextToken } from "@angular/common/http";

export const SKIP_REALM_HEADER = new HttpContextToken<boolean>(() => false)